<template>
  <div>
    <b-row no-gutters>
      <b-col cols="auto">
        <h4>Configuração de Permissões
          <!-- <feather-icon
            v-if="!isAdm"
            color="#008000"
            icon="LockIcon"
            size="16"
          />
          <feather-icon
            v-else
            color="#FF0000"
            icon="UnlockIcon"
            size="16"
          /> -->

        </h4>

      </b-col>
      <b-col class="ml-5">
        <b-row>
          <b-form-checkbox
            v-b-tooltip.hover
            title="Ao marcar um usuário como administrador ele passa a ter acesso ilimitado ao sistema, visualizando todas as empresas cadastradas na base."
            :checked="isAdm"
            switch
            @change="administradorSelecionado($event)"
          />
          <span
            class="d-inline-flex align-items-center"
            style="font-size: 0.857rem;"
          >
            Marcar como administrador
          </span>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <fieldset class="font-weight-bold text-muted small">
          Marque ou desmarque as permissões desejadas
        </fieldset>
        <hr
          class="mx-0 mt-0 mb-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
      </b-col>
    </b-row>
    <grupo-permissao
      v-for="(grupo) in grupos"
      :key="grupo.grupo.nome"
      :recursos="grupo.recursos"
      :grupo="grupo.grupo"
      :is-adm="isAdm"
      :selecionados="recursos"
      @check="selecionadoRecurso"
      @checkAll="selecionadoRecurso"
    />
  </div>
</template>

<style lang="scss"></style>

<script>
import api from '@/app/usuario/shared/services/api'
import { isAdmin } from '@/auth/utils'

export default {
  name: 'ConfigurarPermissoes',
  components: {
    GrupoPermissao: () => import('./GrupoPermissao.vue'),
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    administrador: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAdm: false,
      state: 'none',
      recursos: [],
      grupos: this.getPermissao(),
    }
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.recursos = val
      }
    },
    administrador(val, oldVal) {
      if (val !== oldVal) {
        this.isAdm = val
        this.administradorSelecionado(this.isAdm)
      }
    },
  },
  created() {
    this.recursos = Array.isArray(this.value) ? [...this.value] : []
  },
  methods: {
    getPermissao() {
      const permissoes = localStorage.getItem('permissoes')
      const gruposRecursos = [
        {
          grupo: { nome: 'dashboard', descricao: 'Dashboard' },
          recursos: permissoes.includes('dashboard_analitico') ? [{ nome: 'dashboard_analitico', descricao: 'Analítico' }] : [],
        },
        {
          grupo: { nome: 'federal', descricao: 'Federal' },
          recursos: [
            { nome: 'situacaofiscal_federal', descricao: 'Situação Fiscal' },
            { nome: 'declaracao_dctfweb', descricao: 'DCTFWeb' },
            { nome: 'mit_apuracao', descricao: 'MIT' },
            { nome: 'comprovante_pagamento', descricao: 'Comprovante de arrecadação e-CAC' },
          ].filter(recurso => permissoes.includes(recurso.nome)),
        },
        {
          grupo: { nome: 'certidoes', descricao: 'Certidões' },
          recursos: [
            { nome: 'cnd_federal', descricao: 'RFB/PGFN' },
            { nome: 'cnd_fgts', descricao: 'FGTS' },
            { nome: 'cnd_trabalhista', descricao: 'Trabalhista' },
            // { nome: 'cnd_mte', descricao: 'MTE' },
            { nome: 'cnd_estadual', descricao: 'Estadual' },
            { nome: 'cnd_municipal', descricao: 'Municipal' },
          ].filter(recurso => permissoes.includes(recurso.nome)),
        },
        {
          grupo: { nome: 'caixa_postal', descricao: 'Caixa postal' },
          recursos: [
            { nome: 'caixapostal_ecac', descricao: 'Mensagens e-Cac' },
            { nome: 'caixapostal_dte', descricao: 'DTE' },
            // { nome: 'caixapostal_estadual', descricao: 'Estadual' } // Comentado
          ].filter(recurso => permissoes.includes(recurso.nome)),
        },
        {
          grupo: { nome: 'parcelamento', descricao: 'Parcelamentos' },
          recursos: [
            { nome: 'das_parcelamento', descricao: 'Simples Nacional' },
            { nome: 'parcelamento_pertsn', descricao: 'PERT SN' },
            { nome: 'parcelamento_relpsn', descricao: 'RELP SN' },
            { nome: 'parcelamento_rfb', descricao: 'RFB' },
            { nome: 'parcelamento_naoprevidenciario', descricao: 'Não Previdenciário' },
            { nome: 'pgfn_parcelamento', descricao: 'PGFN' },
            { nome: 'parcelamento_simp_previdenciario', descricao: 'Simplificado Previdenciário' },
          ].filter(recurso => permissoes.includes(recurso.nome)),
        },
        {
          grupo: { nome: 'parcelamento_mei', descricao: 'MEI' },
          recursos: [
            { nome: 'pg_mei', descricao: 'PG MEI' },
            { nome: 'cc_mei', descricao: 'CC MEI' },
            { nome: 'parcelamento_dasmei', descricao: 'Parc MEI' },
            { nome: 'parcelamento_pertmei', descricao: 'Parc PERT' },
            { nome: 'parcelamento_relpmei', descricao: 'Parc RELP' },
          ].filter(recurso => permissoes.includes(recurso.nome)),
        },
        {
          grupo: { nome: 'simplesNacional', descricao: 'Simples Nacional' },
          recursos: [
            { nome: 'das', descricao: 'DAS' },
            { nome: 'sublimite', descricao: 'Sublimite' },
          ].filter(recurso => permissoes.includes(recurso.nome)),
        },
        {
          grupo: { nome: 'documentos', descricao: 'Portal Documentos' },
          recursos: [
            { nome: 'portal_documentos', descricao: 'Downloads' },
            { nome: 'cnd_portal_documentos', descricao: 'CNDs' },
            { nome: 'monitoramento_360', descricao: 'Monitoramento 360' },
          ].filter(recurso => permissoes.includes(recurso.nome)),
        },
        {
          grupo: { nome: 'cadastro', descricao: 'Cadastros' },
          recursos: [
            { nome: 'certificadodigital', descricao: 'Certificados digitais' },
            { nome: 'usuario', descricao: 'Usuários' },
            { nome: 'empresa', descricao: 'Empresas' },
          ].filter(recurso => permissoes.includes(recurso.nome)),
        },
        {
          grupo: { nome: 'permissaoAtualizarRotina', descricao: 'Permissão para atualização de rotinas' },
          // Lista de recursos que pertencem a esse grupo de atualização
          // Cada recurso possui:
          // - nome: identificador único, com padrão <rotina>_atualizacao
          // - descricao: nome legível exibido na UI
          // - rotina: nome da rotina original para aparecer caso o usuario tenha o acesso dispolibilizado
          recursos: [
            { nome: 'situacaofiscal_federal_atualizacao', descricao: 'Situação Fiscal', rotina: 'situacaofiscal_federal' },
            { nome: 'declaracao_dctfweb_atualizacao', descricao: 'DCTFWeb', rotina: 'declaracao_dctfweb' },
            { nome: 'cnd_federal_atualizacao', descricao: 'CND RFB/PGFN', rotina: 'situacaofiscal_federal' },
            { nome: 'cnd_fgts_atualizacao', descricao: 'CND FGTS', rotina: 'cnd_federal' },
            { nome: 'cnd_trabalhista_atualizacao', descricao: 'CND Trabalhista', rotina: 'cnd_trabalhista' },
            { nome: 'das_atualizacao', descricao: 'DAS', rotina: 'das' },
            { nome: 'caixapostal_ecac_atualizacao', descricao: 'Abrir Mensagens e-Cac', rotina: 'caixapostal_ecac' },
            { nome: 'caixapostal_dte_atualizacao', descricao: 'DTE', rotina: 'caixapostal_dte' },
          ].filter(recurso => permissoes.includes(recurso.rotina)),
        },
        {
          grupo: { nome: 'configuracao', descricao: 'Configuração' },
          recursos: [
            { nome: 'perfil_empresa', descricao: 'Perfil da empresa' },
            { nome: 'emailconfig', descricao: 'SMTP' },
            { nome: 'parametro_sistema', descricao: 'Parâmetros do sistema' },
            { nome: 'visualizar_senha_certificado', descricao: 'Visualizar senha Certificado' },
          ].filter(recurso => {
            if (recurso.nome === 'visualizar_senha_certificado') {
              return isAdmin()
            }
            return permissoes.includes(recurso.nome)
          }),
        },
        {
          grupo: { nome: 'lojaVirtual', descricao: 'Loja Virtual' },
          recursos: [
            { nome: 'plano', descricao: 'Plano' },
            { nome: 'aquisicao_credito', descricao: 'Aquisição de créditos' },
            { nome: 'relatorio_consumo', descricao: 'Relatório de consumo' },
          ].filter(recurso => permissoes.includes(recurso.nome)),
        },
      ].filter(grupo => grupo.recursos.length > 0)
      return gruposRecursos
    },
    buscarUsuarioInterno() {
      api.getPermissoesUsuario()
    },
    administradorSelecionado(checked) {
      this.isAdm = checked
      this.$emit('administrador', checked)

      if (checked) {
        const todosRecursos = this.grupos.flatMap(grupo => grupo.recursos.map(recurso => recurso.nome))
        this.recursos = [...todosRecursos]
      }
      this.$emit('input', [...this.recursos])
    },
    selecionadoRecurso(selecionados) {
      this.recursos = [...selecionados]
      this.$emit('input', this.recursos)
      this.$nextTick(() => {
        this.alterarStatusAdministrador()
      })
    },
    alterarStatusAdministrador() {
      if (this.isAdm) {
        const todosRecursos = this.grupos.flatMap(grupo => grupo.recursos.map(recurso => recurso.nome))
        const usuarioTemTodos = todosRecursos.every(recurso => this.recursos.includes(recurso))

        if (this.isAdm && !usuarioTemTodos) {
          this.isAdm = false
          this.$emit('administrador', false)
        }
      }
    },
  },
}
</script>
